import { useForm } from 'react-final-form';

import { AnyFormValues } from '@funnels/types';

export function useFormValues(): [
  AnyFormValues,
  (name: string, value?: any) => void,
  (values: { [key: string]: any }) => void,
  () => Record<string, any>
] {
  const form = useForm();
  const values = form.getState().values as AnyFormValues;
  const setValue = form.change;
  const setValues = (newValues: { [key: string]: any }) => {
    form.batch(() => {
      for (const path in newValues) {
        setValue(path, newValues[path]);
      }
    });
  };
  const getValues = () => form.getState().values;

  return [values, setValue, setValues, getValues];
}
